import { AccountAddEditForm } from '@/components/form/AccountAddEditForm'
export const ContactCreateEdit = ({ actionType }: { actionType: "create" | "edit" }) => {
  return (
    <AccountAddEditForm actionType={actionType} entityType="account"/>
  )
}